import BannerAppsStore from "assets/images/about-us/native_apps_store_banner.png";
import LazyLoad from "components/LazyLoad";

import { Root, Banner } from "./styles";

const NativeAppsBanner = () => {
  return (
    <Root>
      <LazyLoad lazy>
        <Banner src={BannerAppsStore} alt="Native Apps Banner" width={1400} widthMobile={413} />
      </LazyLoad>
    </Root>
  );
};

export default NativeAppsBanner;
